import React, { useContext, useState, useEffect } from "react";
import CustomLayout from "../../Layout/CustomLayout";
import { Typography, Tabs } from "antd";
import SideMenu from "../../Layout/CustomLayout/SideMenu";
import typoStyles from "../../../styles/Custom/Typography.module.css";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { UserContext } from "../../../context/UserContext";
import Service from "./service/Service";
import Categories from "./Categories/Categories";
import Packages from "./Packages/Packages";
import { getCookie } from "../../../helpers/localStorage";
import { Role } from "../../../constants/defaultKeys";
import ReceptionistSideMenu from "../../Layout/CustomLayout/ReceptionistSideMenu";
import useIsMobile from "../../../hooks/useIsMobile";
import styles from "./Services.module.css";

const items = [
 
  {
    key: "services",
    label: "Services",
  },
  {
    key: "packages",
    label: "Packages",
  },
   {
    key: "categories",
    label: "Categories",
  },
];

const Services = () => {
  const isMobile = useIsMobile();
  const { userDetails } = useContext(UserContext);
  const location = useLocation();
  const navigate = useNavigate();
  const query = useParams();
  const params = Object.fromEntries(new URLSearchParams(location?.search));
  const defaultRole = userDetails?.currRole || getCookie(Role);
  const isReceptionist = defaultRole === "Receptionist";
  const [activeTab, setActiveTab] = useState(params?.type || "services");

  useEffect(() => {
    setActiveTab(params?.type || "services");
  }, [params?.type]);

  const onChange = (key) => {
    setActiveTab(key);
    if (defaultRole === "Receptionist") {
      navigate(`/receptionist/services?type=${key}`);
    } else if (defaultRole === "Facility_Admin") {
      navigate(
        `/dashboard/${query["*"]}?type=${key}&facility=${params?.facility}`
      );
    } else {
      navigate(`/dashboard/${query["*"]}?type=${key}`);
    }
  };

  const desktopHeader = (
    <div
      style={{
        gap: "5%",
        width: "100%",
      }}
      className="flex-start"
    >
      <Typography className={typoStyles.h6}>Services & Packages</Typography>
      <Tabs
        style={{ width: "80%", paddingTop: "16px" }}
        activeKey={activeTab}
        items={items}
        onChange={onChange}
      />
    </div>
  );

  const mobileHeader = (
    <Typography className={typoStyles.h6}>Services & Packages</Typography>
  );

  return (
    <CustomLayout
      layoutClassName={isReceptionist ? "reception-layout" : ""}
      header={isMobile ? mobileHeader : desktopHeader}
      sideContent={
        defaultRole === "Receptionist" ? (
          <ReceptionistSideMenu />
        ) : (
          <SideMenu />
        )
      }
    >
      {isMobile && (
        <div className={styles.mobileServicesTabsWrap}>
          <Tabs
            className={styles.mobileServicesTabs}
            activeKey={activeTab}
            items={items}
            onChange={onChange}
          />
        </div>
      )}

      {(params?.type || "services") === "services" ? (
        <Service />
      ) : params?.type === "categories" ? (
        <Categories />
      ) : (
        <Packages />
      )}
    </CustomLayout>
  );
};

export default Services;
